@if (vm$ | async; as vm) {
  <span
    [ngClass]="{ 'cursor-pointer': vm.isClickable }"
    (click)="vm.isClickable ? openWriteOffModal('openWriteOffList', vm.row) : null"
  >
    {{ vm.row[vm.keyname] | currencyformat: vm.convertFromMinorCurrency }}
  </span>
}